import React from 'react'
import StatusBadge, {
  StatusTypes,
} from '@components/common/StatusBadge/StatusBadge.component'

interface ClaimPostingDetailsProps {
  patientName: string
  payerCarrier: string
  subscriber: string
  provider: string
  entityType: string
  claimId: string
  claimStatus: StatusTypes
  submittedAmount: string
  itemType: string
  dateSent: string
  checkNo: string
  checkStatus: string
  paidAmount: string
  modeOfPayment: string
  paymentDate: string
}

const ClaimPostingDetails: React.FC<ClaimPostingDetailsProps> = ({
  patientName,
  payerCarrier,
  subscriber,
  provider,
  entityType,
  claimId,
  claimStatus,
  submittedAmount,
  itemType,
  dateSent,
  checkNo,
  checkStatus,
  paidAmount,
  modeOfPayment,
  paymentDate,
}) => {
  return (
    <div className="claim-posting-details">
      <div className="claim-posting-details-left">
        <div className="cpd-list">
          <div className="cpd-list-left">Patient name</div>
          <div className="cpd-list-right">{patientName}</div>
        </div>
        <div className="cpd-list">
          <div className="cpd-list-left">Payer</div>
          <div className="cpd-list-right">{payerCarrier}</div>
        </div>
        <div className="cpd-list">
          <div className="cpd-list-left">Subscriber</div>
          <div className="cpd-list-right">{subscriber}</div>
        </div>
        <div className="cpd-list">
          <div className="cpd-list-left">Provider</div>
          <div className="cpd-list-right">{provider}</div>
        </div>
        <div className="cpd-list">
          <div className="cpd-list-left">Entity type</div>
          <div className="cpd-list-right">{entityType}</div>
        </div>
      </div>
      <div className="claim-posting-details-middle">
        <div className="cpd-list">
          <div className="cpd-list-left">Claim ID</div>
          <div className="cpd-list-right">{claimId}</div>
        </div>
        <div className="cpd-list">
          <div className="cpd-list-left">Claim status</div>
          <div className="cpd-list-right">
            <StatusBadge status={claimStatus} type="claims" />
          </div>
        </div>
        <div className="cpd-list">
          <div className="cpd-list-left">Claim amount</div>
          <div className="cpd-list-right">${submittedAmount}</div>
        </div>
        <div className="cpd-list">
          <div className="cpd-list-left">Item type</div>
          <div className="cpd-list-right">{itemType}</div>
        </div>
        <div className="cpd-list">
          <div className="cpd-list-left">Claim submitted</div>
          <div className="cpd-list-right">{dateSent}</div>
        </div>
      </div>
      <div className="claim-posting-details-right">
        <div className="cpd-list">
          <div className="cpd-list-left">Check/EFT/Ref no.</div>
          <div className="cpd-list-right">{checkNo}</div>
        </div>
        <div className="cpd-list">
          <div className="cpd-list-left">Status</div>
          {checkStatus === 'N/A' ? (
            <div className="cpd-list-right">N/A</div>
          ) : (
            <StatusBadge status={checkStatus as StatusTypes} type="tracking" />
          )}
        </div>
        <div className="cpd-list">
          <div className="cpd-list-left">Paid amount</div>
          <div className="cpd-list-right">{paidAmount}</div>
        </div>
        <div className="cpd-list">
          <div className="cpd-list-left">Mode of payment</div>
          <div className="cpd-list-right">{modeOfPayment}</div>
        </div>
        <div className="cpd-list">
          <div className="cpd-list-left">Payment date</div>
          <div className="cpd-list-right">{paymentDate}</div>
        </div>
      </div>
    </div>
  )
}

export default ClaimPostingDetails
